export const THEME_PRESETS = {
  'classic-bistro': {
    name: 'Classic Bistro',
    theme: { primaryColor: '#22352a', secondaryColor: '#d5891d', backgroundColor: '#fbf9f0', textColor: '#22352a', font: 'system' },
  },
  'fresh-garden': {
    name: 'Fresh Garden',
    theme: { primaryColor: '#166534', secondaryColor: '#84cc16', backgroundColor: '#fbfff7', textColor: '#102016', font: 'rounded' },
  },
  'coastal-light': {
    name: 'Coastal Light',
    theme: { primaryColor: '#0f766e', secondaryColor: '#38bdf8', backgroundColor: '#f8fdff', textColor: '#12303a', font: 'system' },
  },
  'midnight-bar': {
    name: 'Midnight Bar',
    layout: { categoryNavigation: 'tabs' },
    theme: { primaryColor: '#f59e0b', secondaryColor: '#fb7185', backgroundColor: '#111827', textColor: '#f8fafc', font: 'serif' },
  },
  'dessert-cafe': {
    name: 'Dessert Café',
    theme: { primaryColor: '#db2777', secondaryColor: '#f59e0b', backgroundColor: '#fff7ed', textColor: '#3b2418', font: 'rounded' },
  },
  'minimal-noir': {
    name: 'Minimal Noir',
    layout: { categoryNavigation: 'tabs', density: 'comfortable' },
    theme: { primaryColor: '#6c5140', secondaryColor: '#ad8958', backgroundColor: '#f7f3eb', textColor: '#302923', font: 'serif' },
  },
};

// Local, non-authoritative fallback values — the server (see
// server/src/modules/appearance/schemas/v1.js) is the source of truth and
// always sends a fully-populated config, but components stay defensive in
// case a prop is partial (e.g. in a hand-written test fixture).
export const DEFAULT_APPEARANCE = {
  branding: { logoUrl: null, showLogo: true, showName: true, showDescription: true, coverImageUrl: null },
  theme: {
    preset: 'classic-bistro',
    ...THEME_PRESETS['classic-bistro'].theme,
  },
  layout: { categoryNavigation: 'tabs', itemCardLayout: 'list', imageShape: 'rounded', density: 'comfortable' },
  itemDisplay: { showImages: true, showPrice: true, showDescription: true, showAttributes: true },
};

// A fixed, safe set of system font stacks — no network font loading, which
// keeps the public menu free of an extra render-blocking request (spec
// §13: "font selection from a controlled safe set").
export const FONT_STACKS = {
  system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  serif: 'Georgia, Cambria, "Times New Roman", Times, serif',
  rounded: 'ui-rounded, "Century Gothic", Futura, "Trebuchet MS", sans-serif',
  mono: '"SF Mono", SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace',
};
